import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Al cambiar de ruta (pathname) lleva el scroll al tope. La app tiene dos
 * contenedores de scroll según el viewport:
 *   • mobile  → scroll del documento (window / html-body).
 *   • desktop → el panel de contenido fijo `.content-panel-clip`
 *               (`md:fixed md:overflow-y-auto` en App), no el documento.
 * Reseteamos ambos para cubrir los dos casos.
 *
 * Sólo dependemos de `pathname`: los cambios de vista dentro de una misma
 * página que NO tocan la URL (ej. grid↔detalle vía `history.pushState` con la
 * misma URL, o cambios de query/hash) no disparan esto, así que no pisan sus
 * propias restauraciones de scroll.
 *
 * `useLayoutEffect` corre antes del paint → resetea sin un flash de la página
 * nueva apareciendo scrolleada.
 */
export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
    const panel = document.querySelector<HTMLElement>(".content-panel-clip");
    if (panel) panel.scrollTop = 0;
  }, [pathname]);

  return null;
};

export default ScrollToTop;
